import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card h-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-accent text-white font-weight-bold" }, " Rekap Penjualan Menu ", -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Modal Kembalian", -1)
const _hoisted_6 = { class: "col-lg-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, "Mutasi Modal")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_9 = { class: "col-lg-9" }
const _hoisted_10 = { class: "col-lg-2" }
const _hoisted_11 = { class: "row pt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Sub Total Mutasi Modal", -1)
const _hoisted_13 = { class: "col-lg-2" }
const _hoisted_14 = { class: "row pt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Sisa Modal", -1)
const _hoisted_16 = { class: "col-lg-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, "Penjualan Nota Regular")
], -1)
const _hoisted_19 = { class: "row pt-2" }
const _hoisted_20 = { class: "col-lg-12" }
const _hoisted_21 = { class: "row pt-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_23 = { class: "col-lg-9" }
const _hoisted_24 = { class: "col-lg-2" }
const _hoisted_25 = { class: "row pt-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7" }, "Hrg Reg. Dine In", -1)
const _hoisted_28 = { class: "col-lg-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_30 = { class: "row pt-2" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7" }, "Pajak Dine In", -1)
const _hoisted_33 = { class: "col-lg-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_35 = { class: "row pt-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7" }, "Service Charge Dine In", -1)
const _hoisted_38 = { class: "col-lg-1" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_40 = { class: "row pt-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_42 = { class: "col-lg-9" }
const _hoisted_43 = { class: "col-lg-2" }
const _hoisted_44 = { class: "row pt-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7" }, "Hrg Reg. Take Away", -1)
const _hoisted_47 = { class: "col-lg-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_49 = { class: "row pt-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7" }, "Pajak Take Away", -1)
const _hoisted_52 = { class: "col-lg-1" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_54 = { class: "row pt-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7" }, "Service Charge Take Away", -1)
const _hoisted_57 = { class: "col-lg-1" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_59 = { class: "row pt-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Sub Total Penjualan Harga Regular", -1)
const _hoisted_61 = { class: "col-lg-2" }
const _hoisted_62 = { class: "row pt-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Sub Total Pajak + Service Charge Regular", -1)
const _hoisted_64 = { class: "col-lg-2" }
const _hoisted_65 = { class: "row pt-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Penjualan + Pajak + Service Charge Regular", -1)
const _hoisted_67 = { class: "col-lg-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_69 = { class: "row pt-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Penjualan Nota Ojol", -1)
const _hoisted_71 = { class: "col-lg-2" }
const _hoisted_72 = { class: "row pt-2" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Penjualan dg Harga Regular", -1)
const _hoisted_74 = { class: "col-lg-2" }
const _hoisted_75 = { class: "row pt-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Pajak dg Harga Regular", -1)
const _hoisted_77 = { class: "col-lg-2" }
const _hoisted_78 = { class: "row pt-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Sharing Profit(non pajak)", -1)
const _hoisted_80 = { class: "col-lg-2" }
const _hoisted_81 = { class: "row pt-2" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Penjualan Ojol", -1)
const _hoisted_83 = { class: "col-lg-2" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_85 = { class: "row pt-2" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Penjualan Ojol & Regular", -1)
const _hoisted_87 = { class: "col-lg-2" }
const _hoisted_88 = { class: "row pt-2" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Pajak + SC(Regular & Maxim)", -1)
const _hoisted_90 = { class: "col-lg-2" }
const _hoisted_91 = { class: "row pt-2" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Penjualan (Regular & Ojol) + Pajak & SC(Regular & Maxim)", -1)
const _hoisted_93 = { class: "col-lg-2" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_95 = { class: "row pt-2" }
const _hoisted_96 = { class: "col-lg-10" }
const _hoisted_97 = { class: "col-lg-2" }
const _hoisted_98 = { class: "row pt-2" }
const _hoisted_99 = { class: "col-lg-10" }
const _hoisted_100 = { class: "col-lg-2" }
const _hoisted_101 = { class: "row pt-2" }
const _hoisted_102 = { class: "col-lg-10" }
const _hoisted_103 = { class: "col-lg-2" }
const _hoisted_104 = { class: "row pt-2" }
const _hoisted_105 = { class: "col-lg-10" }
const _hoisted_106 = { class: "col-lg-2" }
const _hoisted_107 = {
  key: 0,
  class: "row pt-2"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Penjualan Lain-lain(0 Nota)", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, "0", -1)
const _hoisted_110 = [
  _hoisted_108,
  _hoisted_109
]
const _hoisted_111 = {
  key: 1,
  class: "row pt-2"
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Pajak Lain-lain(0 %)", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, "0", -1)
const _hoisted_114 = [
  _hoisted_112,
  _hoisted_113
]
const _hoisted_115 = /*#__PURE__*/_createStaticVNode("<div class=\"row pt-2\"><div class=\"col-lg-10\">SUB TOTAL</div><div class=\"col-lg-2\">0</div></div><div class=\"row pt-2\"><div class=\"col-lg-12\"><hr></div></div><div class=\"row pt-2\"><div class=\"col-lg-12\">Pembayaran</div></div>", 3)
const _hoisted_118 = { class: "row pt-2" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Pembayaran Tunai", -1)
const _hoisted_120 = { class: "col-lg-2" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, "Pembayaran Non Tunai")
], -1)
const _hoisted_122 = { class: "row pt-2" }
const _hoisted_123 = { class: "col-lg-12" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_125 = { class: "col-lg-9" }
const _hoisted_126 = { class: "col-lg-2" }
const _hoisted_127 = { class: "row pt-2" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Pembayaran EDC", -1)
const _hoisted_129 = { class: "col-lg-2" }
const _hoisted_130 = { class: "row pt-2" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Pembayaran Non Tunai", -1)
const _hoisted_132 = { class: "col-lg-2" }
const _hoisted_133 = { class: "row pt-2" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Pembayaran", -1)
const _hoisted_135 = { class: "col-lg-2" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, "Pengeluaran Khusus")
], -1)
const _hoisted_138 = { class: "row pt-2" }
const _hoisted_139 = { class: "col-lg-12" }
const _hoisted_140 = {
  key: 0,
  class: "row pt-2"
}
const _hoisted_141 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Tarik Tunai", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, "0", -1)
const _hoisted_144 = [
  _hoisted_141,
  _hoisted_142,
  _hoisted_143
]
const _hoisted_145 = { class: "row pt-2" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Lost Bill", -1)
const _hoisted_148 = { class: "col-lg-2" }
const _hoisted_149 = { class: "row pt-2" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Free Kembalian", -1)
const _hoisted_152 = { class: "col-lg-2" }
const _hoisted_153 = { class: "row pt-2" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Pembulatan", -1)
const _hoisted_156 = { class: "col-lg-2" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, "Promo dan Layanan Konsumen")
], -1)
const _hoisted_159 = { class: "row pt-2" }
const _hoisted_160 = { class: "col-lg-12" }
const _hoisted_161 = { class: "row pt-2" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Gratis/Potongan", -1)
const _hoisted_164 = { class: "col-lg-2" }
const _hoisted_165 = { class: "row pt-2" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Voucher", -1)
const _hoisted_168 = { class: "col-lg-2" }
const _hoisted_169 = { class: "row pt-2" }
const _hoisted_170 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Diskon", -1)
const _hoisted_172 = { class: "col-lg-2" }
const _hoisted_173 = { class: "row pt-2" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Garansi", -1)
const _hoisted_176 = { class: "col-lg-2" }
const _hoisted_177 = { class: "row pt-2" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1" }, null, -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, "Void", -1)
const _hoisted_180 = { class: "col-lg-2" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_182 = { class: "row pt-2" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Uang Tips", -1)
const _hoisted_184 = { class: "col-lg-2" }
const _hoisted_185 = { class: "row pt-2" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Pendapatan + Pajak", -1)
const _hoisted_187 = { class: "col-lg-2" }
const _hoisted_188 = { class: "row pt-2" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Pendapatan Bersih", -1)
const _hoisted_190 = { class: "col-lg-2" }
const _hoisted_191 = { class: "row pt-2" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Cek Pendapatan dan Pembayaran", -1)
const _hoisted_193 = { class: "col-lg-2" }
const _hoisted_194 = { class: "row pt-2" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-10" }, "Total Uang Rill", -1)
const _hoisted_196 = { class: "col-lg-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatMoney(_ctx.modalNominal)), 1)
      ]),
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spendings.spending, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row pt-2",
          key: 'spending-' + index
        }, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, _toDisplayString(item.pengguna), 1),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatMoney(item.nominal)), 1)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.formatMoney(_ctx.spendings.total)), 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.formatMoney(_ctx.remainingModal)), 1)
      ]),
      _hoisted_17,
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, "Dine In(" + _toDisplayString(_ctx.dineInSales.count_nota) + " Nota)", 1),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.formatMoney(_ctx.dineInSales.sales_total)), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatMoney(_ctx.dineInSales.reg_sales_total)), 1),
            _hoisted_29
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.formatMoney(_ctx.dineInSales.reg_sales_tax)), 1),
            _hoisted_34
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.formatMoney(_ctx.dineInSales.reg_sales_service)), 1),
            _hoisted_39
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, "Take Away(" + _toDisplayString(_ctx.takeAwaySales.count_nota) + " Nota)", 1),
            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.formatMoney(_ctx.takeAwaySales.sales_total)), 1)
          ]),
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.formatMoney(_ctx.takeAwaySales.reg_sales_total)), 1),
            _hoisted_48
          ]),
          _createElementVNode("div", _hoisted_49, [
            _hoisted_50,
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.formatMoney(_ctx.takeAwaySales.reg_sales_tax)), 1),
            _hoisted_53
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _hoisted_56,
            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.formatMoney(_ctx.takeAwaySales.reg_sales_service)), 1),
            _hoisted_58
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.formatMoney(_ctx.regSalesTotal)), 1)
      ]),
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.formatMoney(_ctx.taxSrvChargeTotal)), 1)
      ]),
      _createElementVNode("div", _hoisted_65, [
        _hoisted_66,
        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.formatMoney(_ctx.salesTotal)), 1)
      ]),
      _hoisted_68,
      _createElementVNode("div", _hoisted_69, [
        _hoisted_70,
        _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.ojolSales.count_nota), 1)
      ]),
      _createElementVNode("div", _hoisted_72, [
        _hoisted_73,
        _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.formatMoney(_ctx.ojolSales.reg_sales_total)), 1)
      ]),
      _createElementVNode("div", _hoisted_75, [
        _hoisted_76,
        _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.formatMoney(_ctx.ojolSales.reg_sales_tax)), 1)
      ]),
      _createElementVNode("div", _hoisted_78, [
        _hoisted_79,
        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.formatMoney(_ctx.ojolSales.sharing_profit)), 1)
      ]),
      _createElementVNode("div", _hoisted_81, [
        _hoisted_82,
        _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.formatMoney(_ctx.ojolSalesTotal)), 1)
      ]),
      _hoisted_84,
      _createElementVNode("div", _hoisted_85, [
        _hoisted_86,
        _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.formatMoney(_ctx.regOjolTotal)), 1)
      ]),
      _createElementVNode("div", _hoisted_88, [
        _hoisted_89,
        _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.formatMoney(_ctx.regOjolTaxTotal)), 1)
      ]),
      _createElementVNode("div", _hoisted_91, [
        _hoisted_92,
        _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.formatMoney(_ctx.regOjolTotalPlusTax)), 1)
      ]),
      _hoisted_94,
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("div", _hoisted_96, "Penjualan Menu(" + _toDisplayString(_ctx.menuSales.jml_nota) + " Nota)", 1),
        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.formatMoney(_ctx.menuSales.nominal)), 1)
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("div", _hoisted_99, "Pajak Menu(" + _toDisplayString(_ctx.menuSales.pajak) + "%)", 1),
        _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.formatMoney(_ctx.menuSales.nominal_pajak)), 1)
      ]),
      _createElementVNode("div", _hoisted_101, [
        _createElementVNode("div", _hoisted_102, "Penjualan Non Menu(" + _toDisplayString(_ctx.nonMenuSales.jml_nota) + " Nota)", 1),
        _createElementVNode("div", _hoisted_103, _toDisplayString(_ctx.formatMoney(_ctx.nonMenuSales.nominal)), 1)
      ]),
      _createElementVNode("div", _hoisted_104, [
        _createElementVNode("div", _hoisted_105, "Pajak Non Menu(" + _toDisplayString(_ctx.nonMenuSales.pajak) + " %)", 1),
        _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.formatMoney(_ctx.nonMenuSales.nominal_pajak)), 1)
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_107, _hoisted_110))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_111, _hoisted_114))
        : _createCommentVNode("", true),
      _hoisted_115,
      _createElementVNode("div", _hoisted_118, [
        _hoisted_119,
        _createElementVNode("div", _hoisted_120, _toDisplayString(_ctx.formatMoney(_ctx.cashTotal)), 1)
      ]),
      _hoisted_121,
      _createElementVNode("div", _hoisted_122, [
        _createElementVNode("div", _hoisted_123, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payments.paymentDetail, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row pt-2",
              key: 'noncash' + index
            }, [
              _hoisted_124,
              _createElementVNode("div", _hoisted_125, _toDisplayString(item.vendor), 1),
              _createElementVNode("div", _hoisted_126, _toDisplayString(_ctx.formatMoney(item.nominal)), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_127, [
        _hoisted_128,
        _createElementVNode("div", _hoisted_129, _toDisplayString(_ctx.formatMoney(_ctx.payments.edcTotal)), 1)
      ]),
      _createElementVNode("div", _hoisted_130, [
        _hoisted_131,
        _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.formatMoney(_ctx.payments.nonTunaiTotal)), 1)
      ]),
      _createElementVNode("div", _hoisted_133, [
        _hoisted_134,
        _createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.formatMoney(_ctx.paymentTotal)), 1)
      ]),
      _hoisted_136,
      _hoisted_137,
      _createElementVNode("div", _hoisted_138, [
        _createElementVNode("div", _hoisted_139, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_140, _hoisted_144))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_145, [
            _hoisted_146,
            _hoisted_147,
            _createElementVNode("div", _hoisted_148, _toDisplayString(_ctx.formatMoney(_ctx.promo.total_lost_bills)), 1)
          ]),
          _createElementVNode("div", _hoisted_149, [
            _hoisted_150,
            _hoisted_151,
            _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.formatMoney(_ctx.promo.free_kembalian)), 1)
          ]),
          _createElementVNode("div", _hoisted_153, [
            _hoisted_154,
            _hoisted_155,
            _createElementVNode("div", _hoisted_156, _toDisplayString(_ctx.formatMoney(_ctx.promo.pembulatan)), 1)
          ])
        ])
      ]),
      _hoisted_157,
      _hoisted_158,
      _createElementVNode("div", _hoisted_159, [
        _createElementVNode("div", _hoisted_160, [
          _createElementVNode("div", _hoisted_161, [
            _hoisted_162,
            _hoisted_163,
            _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.promo.gratis), 1)
          ]),
          _createElementVNode("div", _hoisted_165, [
            _hoisted_166,
            _hoisted_167,
            _createElementVNode("div", _hoisted_168, _toDisplayString(_ctx.promo.voucher), 1)
          ]),
          _createElementVNode("div", _hoisted_169, [
            _hoisted_170,
            _hoisted_171,
            _createElementVNode("div", _hoisted_172, _toDisplayString(_ctx.promo.diskon), 1)
          ]),
          _createElementVNode("div", _hoisted_173, [
            _hoisted_174,
            _hoisted_175,
            _createElementVNode("div", _hoisted_176, _toDisplayString(_ctx.promo.total_warranty), 1)
          ]),
          _createElementVNode("div", _hoisted_177, [
            _hoisted_178,
            _hoisted_179,
            _createElementVNode("div", _hoisted_180, _toDisplayString(_ctx.promo.void_total), 1)
          ])
        ])
      ]),
      _hoisted_181,
      _createElementVNode("div", _hoisted_182, [
        _hoisted_183,
        _createElementVNode("div", _hoisted_184, _toDisplayString(_ctx.formatMoney(_ctx.promo.total_uang_tips)), 1)
      ]),
      _createElementVNode("div", _hoisted_185, [
        _hoisted_186,
        _createElementVNode("div", _hoisted_187, _toDisplayString(_ctx.formatMoney(_ctx.incomeTax)), 1)
      ]),
      _createElementVNode("div", _hoisted_188, [
        _hoisted_189,
        _createElementVNode("div", _hoisted_190, _toDisplayString(_ctx.formatMoney(_ctx.promo.nominal)), 1)
      ]),
      _createElementVNode("div", _hoisted_191, [
        _hoisted_192,
        _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.formatMoney(_ctx.incomeAndPaymentCheck)), 1)
      ]),
      _createElementVNode("div", _hoisted_194, [
        _hoisted_195,
        _createElementVNode("div", _hoisted_196, _toDisplayString(_ctx.formatMoney(_ctx.realMoneyTotal)), 1)
      ])
    ])
  ]))
}